export default __webpack_public_path__ + "static/media/ioasys.ebdad741.gif";